var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media-caption caption",class:`caption-align-${_vm.textAlign}`},[(_vm.$slots.desc)?_c('div',{staticClass:"caption-main din uppercase"},[_vm._t("desc")],2):_vm._e(),(_vm.$slots.sub)?_c('div',{staticClass:"caption-sub italic grey2"},[_vm._t("sub")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }